import { render } from "./lookup.vue?vue&type=template&id=40f64531&scoped=true&ts=true"
import script from "./lookup.vue?vue&type=script&lang=ts"
export * from "./lookup.vue?vue&type=script&lang=ts"

import "./lookup.vue?vue&type=style&index=0&id=40f64531&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f64531"]])

export default __exports__